export default "__VITE_ASSET__Co7BBVga__"